<template>
    <div class="actions-log-wrapper" v-if="actionsLog.length">
        <span class="arrow prev" @click="onPrev">
            <fa-icon
                class="arrow-icon"
                icon="chevron-left"
                v-if="showPrevArrow"
            />
        </span>
        <div class="actions-log" ref="actions-log" @click="showActionsLogModal()">
            <div class="action-log" :class="{[log.color]: true}">
                <span class="action-log-icon">
                    <royal-coin :color="log.color" :theme="theme" />
                </span>
                <span class="action-log-text"> {{ log.label }} </span>
            </div>
        </div>
        <span class="arrow next" @click="onNext">
            <fa-icon
                class="arrow-icon"
                icon="chevron-right"
                v-if="showNextArrow"
            />
        </span>
    </div>

</template>

<script>
export default {
    name: 'ActionsLog',
    props: ['actionsLog'],
    data() {
        return {
            current: 0,
        };
    },
    watch: {
        actionsLog(current, prev) {
            if (current.length !== prev.length) {
                this.current = 0;
            }
        },
    },
    computed: {
        showPrevArrow() {
            return this.actionsLog[this.current + 1];
        },
        showNextArrow() {
            return this.actionsLog[this.current - 1];
        },
        log() {
            return this.actionsLog[this.current];
        },
        ref() {
            return this.$refs['actions-log'];
        },
        theme() {
            return this.$store.state.gameState.theme;
        },
    },
    methods: {
        showActionsLogModal() {
            this.$store.dispatch('openModal', { type: 'actionsLog' });
        },
        onNext() {
            const next = this.current - 1;

            if (this.actionsLog[next]) {
                this.current = next;
            }
        },
        onPrev() {
            const prev = this.current + 1;

            if (this.actionsLog[prev]) {
                this.current = prev;
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .actions-log-wrapper {
        color: $dark-gray;
        display: flex;
        position: relative;
        z-index: 3;

        > * {
            display: inline-block;
        }

        &:hover {

            .arrow {

                .arrow-icon {
                    animation-name: fade-in;
                }
            }
        }

        .arrow {
            align-self: center;
            display: inline-block;
            line-height: 1.2em;
            height: 18px;
            width: 18px;

            .arrow-icon {
                cursor: pointer;
                vertical-align: middle;
                color: $royal-coin-black;
                font-size: .75em;
                opacity: 0;
                animation-duration: .5s;
                animation-fill-mode: forwards;
            }
        }

        .actions-log {
            flex-grow: 1;

            .action-log {
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                cursor: pointer;
                display: flex;
                user-select: none;
                text-align: left;
                padding: 0 3px;

                > * {
                    align-self: center;
                }

                .royal-coin {
                    height: 18px;
                    width: 18px;
                }

                .action-log-icon {
                    height: 18px;
                    line-height: 1.2em;
                }

                .action-log-text {
                    color: $dark-gray;
                    font-family: 'Avenir', 'RobotoSlab', Helvetica, Arial, sans-serif;
                    font-size: .7em;
                    font-weight: 400;
                    line-height: 1.2em;
                    max-width: 300px;
                    padding-left: 5px;
                    vertical-align: middle;
                }
            }
        }
    }

    @media only screen and (min-width: $screen-xs) {

        .actions-log-wrapper {

            .arrow {
                width: 20px;
                height: 20px;

                .arrow-icon {
                    font-size: .85em;
                }
            }

            .actions-log {

                .action-log {

                    .action-log-icon {
                        height: 20px;
                    }

                    .royal-coin {
                        height: 20px;
                        width: 20px;
                    }

                    .action-log-text {
                        font-size: .85em;
                    }
                }
            }
        }

        .board-wrapper {

            .actions-log-wrapper {
                position: absolute;
                right: 7.5%;
                top: 4%;
            }
        }
    }

</style>
